function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
var prefixCls = 'eui-upload';

var Upload = /*#__PURE__*/function (_React$Component) {
  _inherits(Upload, _React$Component);

  var _super = _createSuper(Upload);

  function Upload() {
    var _this;

    _classCallCheck(this, Upload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      fileList: []
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.input.click();
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      if (e.target instanceof HTMLInputElement) {
        var _this$props = _this.props,
            autoUpload = _this$props.autoUpload,
            multiple = _this$props.multiple;
        var files = e.target.files;

        if (!files) {
          return;
        }

        var fileList = Array.prototype.slice.call(files);

        if (!multiple) {
          fileList = fileList.slice(0, 1);
        }

        if (autoUpload) {
          _this.uploadFiles(fileList);
        } else {
          _this.setState({
            fileList: fileList
          });
        }

        _this.input.value = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "uploadFiles", function (files) {
      var _this$props2 = _this.props,
          limit = _this$props2.limit,
          onExceed = _this$props2.onExceed;

      if (limit && files.length > limit) {
        if (onExceed) onExceed(files);
        return;
      }

      if (files.length === 0) {
        return;
      }

      files.forEach(function (file) {
        _this.upload(file);
      });
    });

    return _this;
  }

  _createClass(Upload, [{
    key: "upload",
    value: function upload(file) {
      var httpRequest = this.props.httpRequest;
      httpRequest({
        file: file
      });
    } // 使用者通过ref.submit调用该方法

  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;

      var fileList = this.state.fileList;
      fileList.forEach(function (file) {
        _this2.upload(file);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          multiple = _this$props3.multiple,
          accept = _this$props3.accept,
          children = _this$props3.children,
          trigger = _this$props3.trigger,
          autoUpload = _this$props3.autoUpload,
          onExceed = _this$props3.onExceed,
          httpRequest = _this$props3.httpRequest,
          other = _objectWithoutProperties(_this$props3, ["multiple", "accept", "children", "trigger", "autoUpload", "onExceed", "httpRequest"]);

      return /*#__PURE__*/React.createElement("div", _extends({
        className: prefixCls
      }, other), /*#__PURE__*/React.createElement("div", {
        onClick: this.handleClick
      }, trigger || children), trigger ? children : null, /*#__PURE__*/React.createElement("input", {
        className: "".concat(prefixCls, "-input"),
        type: "file",
        ref: function ref(el) {
          _this3.input = el;
        },
        onChange: function onChange(e) {
          return _this3.handleChange(e);
        },
        multiple: multiple,
        accept: accept,
        style: {
          display: 'none'
        }
      }));
    }
  }]);

  return Upload;
}(React.Component);

_defineProperty(Upload, "defaultProps", {
  autoUpload: false,
  multiple: false,
  accept: '',
  limit: undefined,
  trigger: null,
  onExceed: function onExceed() {}
});

Upload.propTypes = {
  autoUpload: PropTypes.bool,
  multiple: PropTypes.bool,
  accept: PropTypes.string,
  limit: PropTypes.number,
  trigger: PropTypes.node,
  onExceed: PropTypes.func
};
export default Upload;